import {
  CACHE_KEY_REQUEST_ASYNC,
  CAMPAIGN_FILTER_CHANGE,
  CAMPAIGNS_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  REPORT_REQUEST_ASYNC,
} from './constants'

const fetchCampaigns = () => ({ type: CAMPAIGNS_REQUEST_ASYNC.INITIATE })
export const fetchCampaignsSuccess = (data) => ({
  type: CAMPAIGNS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCampaignsError = (error) => ({
  type: CAMPAIGNS_REQUEST_ASYNC.ERROR,
  error,
})
const fetchCampaignsCancel = () => ({ type: CAMPAIGNS_REQUEST_ASYNC.CANCEL })

const getCacheKey = (data) => ({
  type: CACHE_KEY_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const getCacheKeySuccess = (key) => ({
  type: CACHE_KEY_REQUEST_ASYNC.SUCCESS,
  payload: { key },
})
export const getCacheKeyError = (error) => ({
  type: CACHE_KEY_REQUEST_ASYNC.ERROR,
  error,
})

const fetchReport = () => ({ type: REPORT_REQUEST_ASYNC.INITIATE })
export const fetchReportSuccess = (data) => ({
  type: REPORT_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchReportError = (error) => ({
  type: REPORT_REQUEST_ASYNC.ERROR,
  error,
})

const dateFilterChange = (value, isNeedsFetch = true) => ({
  type: DATE_FILTER_CHANGE,
  payload: { value, isNeedsFetch },
})
const campaignFilterChange = (selectedCampaignIds, withCustomIds, dateFilter, filters) => ({
  type: CAMPAIGN_FILTER_CHANGE,
  payload: {
    selectedCampaignIds: selectedCampaignIds.map((id) => parseInt(id)),
    withCustomIds,
    dateFilter,
    filters,
  },
})
export default {
  // to props
  fetchCampaigns,
  fetchCampaignsCancel,
  getCacheKey,
  dateFilterChange,
  campaignFilterChange,
  fetchReport,
}
